import i18n from '@/plugins/vue-i18n-config';

export default [
  {
    path: 'department',
    name: 'mainDepartments',
    component: () => import('../../views/Main/Department'),
    redirect: { name: 'mainDepartmentsList' },
    children: [
      {
        path: 'index',
        name: 'mainDepartmentsList',
        component: () => import('../../views/Main/Department/List'),
        meta: {
          title() {
            return i18n.tc('menu.office', 2) + ' | KPI';
          }
        }
      },
      {
        path: 'create',
        name: 'mainDepartmentsCreate',
        component: () => import('../../views/Main/Department/Create'),
        meta: {
          title() {
            return (
              i18n.t('crudCreate', {
                text: i18n.tc('menu.office', 1).toLowerCase()
              }) + ' | KPI'
            );
          }
        }
      },
      {
        path: 'update/:id',
        props: true,
        name: 'mainDepartmentsUpdate',
        component: () => import('../../views/Main/Department/Update'),
        meta: {
          title(name) {
            return (
              i18n.t('crudEdit', {
                table: i18n.tc('menu.office', 1).toLowerCase(),
                name: name
              }) + ' | KPI'
            );
          }
        }
      },
      {
        path: 'staffs/:id',
        name: 'mainDepartmentStaff',
        component: () => import('../../views/Main/Department/Staff/Read'),
        props: true,
        meta: {
          title(name) {
            return (
              i18n.t('crudRead', {
                table: 'Staff',
                name: name
              }) + ' | KPI'
            );
          }
        }
      }
    ]
  }
];
